import { createSelector } from "@reduxjs/toolkit";
import { initialState, type LoginState } from "./slice";

const loginInitialState = (state: { login?: LoginState }): LoginState =>
  state.login || initialState;

export const selectLogin = createSelector(
  [loginInitialState],
  (state) => state.login,
);

export const selectGoogleLogin = createSelector(
  [loginInitialState],
  (state) => state.googleLogin,
);
